import * as Auth from "../services/auth";
import { useGlobalContext } from "../utils/global-context";

function useAuth() {
	const context = useGlobalContext();
	const isAuthorized = Auth.isAuthorized(context);
	return { isAuthorized };
}

export default useAuth;
